// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.features_header__DZBPJ {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  max-width: 800px;
  width: 100%;
  margin: 0 auto;
  text-align: center;
  grid-gap: 10px;
  margin-top: 100px;
  color: #111827;
  font-family: Inter;
}
.features_header__DZBPJ h3 {
  font-size: 48px;
  font-weight: 700;
  letter-spacing: -1px;
}
.features_header__DZBPJ p {
  font-size: 18px;
  font-weight: 400;
  line-height: 28px;
}

.features_wrapper__Qi27v {
  margin-top: 65px;
  display: flex;
  align-items: stretch;
  grid-gap: 60px;
  flex-wrap: wrap;
}

.features_card__cKo4U {
  max-width: 352px;
  width: 100%;
  font-family: Inter;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
.features_card__cKo4U h4 {
  color: #111827;
  font-weight: 700;
  font-size: 30px;
}
.features_card__cKo4U p {
  color: #374151;
  margin-top: 8px;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
}

@media (max-width: 1235px) {
  .features_wrapper__Qi27v {
    justify-content: center;
  }
}
@media (max-width: 430px) {
  .features_wrapper__Qi27v {
    justify-content: center;
  }
  .features_header__DZBPJ h3 {
    font-size: 36px;
  }
  .features_header__DZBPJ p {
    font-size: 16px;
    line-height: 21px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/features/features.module.scss"],"names":[],"mappings":"AAGA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,gBAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AAFF;AAIE;EACE,eAAA;EACA,gBAAA;EACA,oBAAA;AAFJ;AAME;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AAJJ;;AAQA;EACE,gBAAA;EACA,aAAA;EACA,oBAAA;EACA,cAAA;EACA,eAAA;AALF;;AAQA;EACE,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;AALF;AAOE;EACE,cAAA;EACA,gBAAA;EACA,eAAA;AALJ;AAQE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AANJ;;AAUA;EACE;IACE,uBAAA;EAPF;AACF;AAUA;EACE;IACE,uBAAA;EARF;EAYE;IACE,eAAA;EAVJ;EAYE;IACE,eAAA;IACA,iBAAA;EAVJ;AACF","sourcesContent":["\r\n\r\n\r\n.header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-direction: column;\r\n  max-width: 800px;\r\n  width: 100%;\r\n  margin: 0 auto;\r\n  text-align: center;\r\n  grid-gap: 10px;\r\n  margin-top: 100px;\r\n  color: #111827;\r\n  font-family: Inter;\r\n\r\n  h3 {\r\n    font-size: 48px;\r\n    font-weight: 700;\r\n    letter-spacing: -1px;\r\n\r\n  }\r\n\r\n  p {\r\n    font-size: 18px;\r\n    font-weight: 400;\r\n    line-height: 28px;\r\n  }\r\n}\r\n\r\n.wrapper {\r\n  margin-top: 65px;\r\n  display: flex;\r\n  align-items: stretch;\r\n  grid-gap: 60px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.card {\r\n  max-width: 352px;\r\n  width: 100%;\r\n  font-family: Inter;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  text-align: center;\r\n\r\n  h4 {\r\n    color: #111827;\r\n    font-weight: 700;\r\n    font-size: 30px;\r\n  }\r\n\r\n  p {\r\n    color: #374151;\r\n    margin-top: 8px;\r\n    font-weight: 400;\r\n    font-size: 16px;\r\n    line-height: 24px;\r\n  }\r\n}\r\n\r\n@media (max-width: 1235px) {\r\n  .wrapper {\r\n    justify-content: center;\r\n  }\r\n}\r\n\r\n@media (max-width: 430px) {\r\n  .wrapper {\r\n    justify-content: center;\r\n  }\r\n\r\n  .header {\r\n    h3 {\r\n      font-size: 36px;\r\n    }\r\n    p {\r\n      font-size: 16px;\r\n      line-height: 21px;\r\n    }\r\n  }\r\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `features_header__DZBPJ`,
	"wrapper": `features_wrapper__Qi27v`,
	"card": `features_card__cKo4U`
};
export default ___CSS_LOADER_EXPORT___;
